export default {
    t: {
        placeholderA:'Select a Channel…',
        btn:'Upload',
        title: 'Headline',
        desc: 'Brief Introduction',
        upload: 'Files To Be Uploaded',
        other: 'Other',
        Channel: 'Channel',
        Source: 'Source'
    },
    c: {
        a: "An eye-catching headline is always indispensable.",
        b: "For the brief introduction, the shorter, the better. It would be enough to explain why and how within 150 words in brief.",
        c: {
            0:'Please choose to submit at least ONE between video and pictures. ',
            1:'If both a video and pictures are submitted, the video file will be played first.',
            2:'The max size of the video is not more than 30M. And the format shall be MP4, HD1080 (H.264, 1920x1080; AAC,320Kbps, Stereo).',
            3:'The picture must be in JPG/JPEG/PNG format with maximum size of 1500*1500, 300dpi. And 5~8 pictures shall be great and enough.'
        },
        d: {
            0:'Conceptual Design: e.g. Homeland On Mars - at the conceptual stage, no prototype product, only Demo exits for feasibility study.',
            1:"Prototype Design: e.g. Musk's Mars spacecraft - has moved beyond conceptual design and is being tested to validate the concept for scale commercialization.",
            2:'Innovative Design: e.g. SawStop - innovative improvements to an existing commercialized product to better perform its original or added functions.',
            3:'Product Design: e.g. ROYOLE Flexible Screen - no similar product before, has completed the concept, prototype stage, and has been commercialized.',
            4:'Innovative Method: e.g., innovative hydrogen production processes - using an entirely new method to obtain or manufacture a product.',
            5:'Innovative Material: e.g. DCLAN - a method or formula to obtain, manufacture, or synthesize an entirely new material.'

        },
        e:"We respect originality. Any plagiarism is a crime. So please make sure to provide the source of your citation. And the link must match the content to be shared."
  },

}